import React from 'react';

const ServiceCard = () => {
  return (
    <section className="bg-white py-12 sm:py-20 font-sans">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

    {/* Section Heading */}
    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-cogBrand mb-4 tracking-tight">
      Custom Wiring Harnesses for Your Application
    </h2>

    <p className="text-base sm:text-lg text-cogBlue/80 max-w-4xl mb-8 sm:mb-12 leading-relaxed">
      Every application has unique electrical and mechanical requirements. We develop custom wiring harness solutions engineered for seamless integration, dependable performance, and efficient manufacturing, supporting projects from prototype development to full-scale production.
    </p>

    {/* Responsive Grid Matrix */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">

      {/* Card 1: Prototype Development */}
      <div className="bg-gray-50/50 border border-gray-200 flex flex-col md:flex-row group overflow-hidden rounded-sm hover:shadow-md hover:border-cogCyan/30 transition-all duration-300">
        <div className="w-full md:w-1/3 min-h-[180px] sm:min-h-[200px] relative overflow-hidden">
          <img
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            alt="Prototype wiring harness engineering and design"
            src="https://www.zuken.com/en/wp-content/uploads/sites/2/2018/10/engineers-using-e3series-electrical-design.png"
          />
        </div>

        <div className="w-full md:w-2/3 p-6 sm:p-8 flex flex-col justify-between">
          <div>
            <h3 className="text-lg sm:text-xl font-bold text-cogBrand mb-4 tracking-tight">
              Prototype Development
            </h3>

            <p className="text-sm sm:text-base text-cogBlue/80 leading-relaxed">
              We transform concepts into functional prototypes through detailed engineering, design validation, and rapid development. Working closely with customers, we refine harness layouts, optimize manufacturability, and validate performance before moving into production.
            </p>
          </div>
        </div>
      </div>

      {/* Card 2: Custom Harness Manufacturing */}
      <div className="bg-gray-50/50 border border-gray-200 flex flex-col md:flex-row group overflow-hidden rounded-sm hover:shadow-md hover:border-cogCyan/30 transition-all duration-300">
        <div className="w-full md:w-1/3 min-h-[180px] sm:min-h-[200px] relative overflow-hidden">
          <img
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            alt="Custom wiring harness manufacturing"
            src="https://www.zuken.com/en/wp-content/uploads/sites/2/2020/09/mbse-wireharness-1510x731.jpg"
          />
        </div>

        <div className="w-full md:w-2/3 p-6 sm:p-8 flex flex-col justify-between">
          <div>
            <h3 className="text-lg sm:text-xl font-bold text-cogBrand mb-4 tracking-tight">
              Custom Harness Manufacturing
            </h3>

            <p className="text-sm sm:text-base text-cogBlue/80 leading-relaxed">
              We manufacture custom wiring harnesses, cable assemblies, battery cables, PCB harnesses, and application-specific electrical interconnect solutions. Every assembly is produced using precision manufacturing processes and rigorous quality control for reliable performance.
            </p>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
  );
};

export default ServiceCard;